import usePrivateAxios from "@/common/api/usePrivateAxios";
import { useMutation } from "@tanstack/react-query";
import { ErrorResponse } from "@/common/types/errorResponse";
import { ClientUserBranchAccessValidationSchema } from "../schemas/updateUserAccesses.schema";
import { CompanyBranchData } from "@/features/company/types/company.type";

interface UseCreateCompanyBranchUserAccessesProps {
  companyBranch?: CompanyBranchData;
  onSuccess?: () => void;
  onError?: (error: ErrorResponse) => void;
}

export const useCreateCompanyBranchUserAccesses = ({ companyBranch, onSuccess, onError }: UseCreateCompanyBranchUserAccessesProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['createCompanyBranchUserAccesses', companyBranch?.id],
    mutationFn: (data: ClientUserBranchAccessValidationSchema) => {
      const payload = {
        user_branch_accesses_attributes: [
          {
            user_id: data.user.value,
            branch_hierarchy_for_user_access: data.branch_hierarchy_for_user_access.value,
          }
        ]
      }

      return privateAxios.put(`/company_branches/${companyBranch?.id}/update_user_accesses`, {
        company_branch: payload,
      });
    },
    onSuccess,
    onError,
  });
}
